import { register } from "async-ops";
import { callMvcApi } from "../../../call-web-api";
export const GET_DOCUMENT_OCR_STATUS =
  "GET_DOCUMENT_OCR_STATUS";

export const service = async (s3ObjectName) => {
  const options: object = {
    url: `/Api/Document/GetDocumentOCRStatus?s3ObjectName=${encodeURIComponent(s3ObjectName)}`,
    method: "GET",
  };
  const response = callMvcApi(options);
  return response;
};

const mockData = () => {
  return [];
};

const mock = () => {
  const promise = new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(mockData());
    }, 2000);
  });
  return promise;
};

register(GET_DOCUMENT_OCR_STATUS, service, mock);
